import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { IconService, IconType } from '../../../services/icons.service';

/**
 * The icon component
 */
@Component({
  standalone: true,
  selector: 'lf-icon',
  styleUrls: ['./icons-svgs.component.scss'],
  templateUrl: './icons-svgs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [IconService],
  imports: [NgClass]
})
export class IconComponent {
  /**
   * The size of the icon. Accepts valid CSS values
   */
  @Input() height = '32px';
  @Input() width = '32px';
  /**
   * The name of the icon to render
   */
  @Input() name: IconType;
  @Input() fillColor = "none";
  @Input() scale = '1';

  protected get svg(): SafeHtml {
    const svgContent = this.iconService.getSvgForName(this.name);
    return this.sanitizer.bypassSecurityTrustHtml(svgContent);
  }

  constructor(private sanitizer: DomSanitizer, private iconService: IconService) {}
}